import {} from "../env/index.js";
import {} from "../node/index.js";
import {} from "./Rule.js";
import { disconnectNodeAndMatchParameters } from "./disconnectNodeAndMatchParameters.js";
export function exposeRuleTargets(env, rule, [firstNode, secondNode]) {
    if (rule.first.name === firstNode.name ||
        rule.second.name === secondNode.name) {
        disconnectNodeAndMatchParameters(env, firstNode, rule.first.parameters);
        disconnectNodeAndMatchParameters(env, secondNode, rule.second.parameters);
        return;
    }
    if (rule.first.name === secondNode.name ||
        rule.second.name === firstNode.name) {
        disconnectNodeAndMatchParameters(env, secondNode, rule.first.parameters);
        disconnectNodeAndMatchParameters(env, firstNode, rule.second.parameters);
        return;
    }
}
//# sourceMappingURL=exposeRuleTargets.js.map